// extracted by mini-css-extract-plugin
export default {"title__container":"DoughnutBoxTitle_title__container__yC1dq","title__icon":"DoughnutBoxTitle_title__icon__mQwT4"};